import { TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useState } from 'react';

import { UpdateAnonymousTripModal } from './anonymous/UpdateAnonymousTripModal';
import { useFetchAnonymousCanUpdateTrip } from '../../../hooks/useFetchAnonymousCanUpdateTrip';
import { t } from '../../../services/translation/translation';
import { SecondaryButton } from '../../button/SecondaryButton';

type Props = { trip: TripOutput; jwtToken: string };

export const UpdateTripButtonAnonymous = ({ trip, jwtToken }: Props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { data, isLoading } = useFetchAnonymousCanUpdateTrip({ key: trip.key, jwtToken: jwtToken });

  return (
    <>
      {(data?.canUpdateDepartureAt === false &&
        data?.canUpdateEndAddress === false &&
        data?.canUpdateStartAddress === false) ||
      isLoading ? null : (
        <>
          <SecondaryButton className="w-full mt-2" onClick={() => setIsModalVisible(true)}>
            {t('common.update')}
          </SecondaryButton>
          {isModalVisible ? (
            jwtToken ? (
              <UpdateAnonymousTripModal
                trip={trip}
                jwtToken={jwtToken}
                data={data}
                isLoading={isLoading}
                onClose={() => setIsModalVisible(false)}
              />
            ) : null
          ) : null}
        </>
      )}
    </>
  );
};
